import { HTMLProps } from 'react'

interface TableHeadProps extends HTMLProps<HTMLTableSectionElement> {}

export function Head(props: TableHeadProps) {
    return (
        <thead>
        <tr>
            <th className={'text-start align-bottom py-2 ps-4 pe-6'}>
                <div>#&nbsp;&nbsp;Name</div>
            </th>
            <th className={'text-end align-bottom py-2 px-6'}>
                <div>Price</div>
            </th>
            <th className={'text-end align-bottom py-2 px-6'}>
                <div>Shielded<br/>Market cap</div>
            </th>
            <th className={'text-center align-bottom py-2 px-6'}>
                <div>Shielded %</div>
            </th>
            <th className={'text-end align-bottom py-2 px-6'}>
                <div>Price USD 30D</div>
            </th>
            {/*<th className={'text-end align-bottom py-2 px-6'}>*/}
            {/*    <div>Privacy method</div>*/}
            {/*</th>*/}
            <th className={'text-end align-bottom py-2 px-6'}>
                <div>Price BTC 30D</div>
            </th>
            <th className={'text-center align-bottom py-2 ps-6 pe-3'}>
                <div>Dominance %</div>
            </th>
        </tr>
        </thead>
    )
}